import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import OrderReturnList from '../entities/back-shopeeorderreturn'
import appconst from '@/lib/appconst';


interface OrderReturnState extends ListState<OrderReturnList> {
    OrderReturnList: OrderReturnList,
}

class BackOrderReturn extends ListMutations<OrderReturnList>{

}
class OrderReturn extends ListModule<OrderReturnState, any, OrderReturnList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OrderReturnList>(),
        loading: false,
        orderReturnInfo: OrderReturnList,


    }
    actions = {
        async getAll(context: ActionContext<OrderReturnState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ShopeeOrderReturn/GetShopeeOrderReturnList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<OrderReturnList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async editOrderReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/ShopeeOrderReturn/Update', payload.data);
        },
        async getUserCode(context: ActionContext<OrderReturnState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/ShopeeOrderReturn/CheckUserCode?orderNumber=' + payload.data.orderNumber + '&warehouseInfoId=' + payload.data.warehouseInfoId, payload.data);
            return rep.data.result;
        },
    };
    mutations = {
        setCurrentPage(state: OrderReturnState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OrderReturnState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}

const orderreturn = new OrderReturn();
export default orderreturn;